import { Navigate, useLocation } from "react-router-dom";

import AuthenticatedLayout from "./AuthenticatedLayout";

import { useAuth } from "../context/AuthContext";
import { canAccessPath, getDefaultHomePath } from "../lib/screenAccess";
import { pathToScreenKey } from "../constants/screenCatalog";

interface ProtectedRouteProps {
  children: React.ReactNode;
  noLayout?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  noLayout = false,
}) => {
  const { token, user } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const pathname = location.pathname;
  const key = pathToScreenKey(pathname);

  if (key && !canAccessPath(user, pathname)) {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  if (!key && pathname !== "/") {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  if (noLayout) {
    return <>{children}</>;
  }

  return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
};

export default ProtectedRoute;
